<template>
  <h2>
    {{ $t('menu') }}
  </h2>
  <div style="scroll-behavior: smooth">
    <div class="main-info">
      <div ref="menu" class="paragraph-block">
        <img
          v-if="locale === 'ru'"
          :src="`${staticUrl}/images/interior-design-2.webp`"
          alt=""
          class="article-image"
        />
        <img
          v-else
          :src="`${staticUrl}/images/interior-design-en-2.webp`"
          alt=""
          class="article-image"
        />
        <div id="settings" ref="settings" class="sub-paragraph-block">
          <h3 ref="settings" id="cameraModeSettings">
            {{ $t('cameraModeSettingsT2') }}
          </h3>
          <h4>
            {{ $t('cameraModeSettingsT1') }}
          </h4>
          <p class="mb-5">{{ $t('howToCreateContentInstr') }}</p>
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-3.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-3.webp`"
            alt=""
            class="article-image"
          />
          <!-- <p class="sub-paragraph-text">
            {{ $t('settingsGeneralEtcEntry') }}
          </p> -->
          <div class="paragraph-steps">
            <h4>
              {{ $t('cameraModeSettingsT2') }}
            </h4>
            <div class="step-block">
              <p>
                {{ $t('cameraModeSettingsT3') }}
              </p>
              <p>
                {{ $t('cameraModeSettingsT4') }}
              </p>
              <p>
                {{ $t('cameraModeSettingsT5') }}
              </p>

              <p>
                {{ $t('cameraModeSettingsT6') }}
              </p>
              <p>
                {{ $t('cameraModeSettingsT7') }}
              </p>
              <p>
                {{ $t('cameraModeSettingsT8') }}
              </p>
            </div>
          </div>
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-3.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-3.webp`"
            alt=""
            class="article-image"
          />
          <h3 class="mt-5" id="settingsGeneralEtc">
            {{ $t('settingsGeneralEtc') }}
          </h3>
          <p>{{ $t('settingsGeneralEtcT1') }}</p>
          <p>{{ $t('settingsGeneralEtcEntry') }}</p>
          <div class="paragraph-steps">
            <h4>
              {{ $t('oneGeneralSetting') }}
            </h4>
            <div class="step-block">
              <p class="step-element">
                {{ $t('functionsAvailableGeneralSettings') }}
              </p>
              <p class="step-element">
                {{ $t('autosaveSaveDesignRealTime') }}
              </p>
              <p class="step-element">
                {{ $t('languageDreamFlatInterface') }}
              </p>

              <p class="step-element">
                {{ $t('tvSettings') }}
              </p>
            </div>
          </div>
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-3.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-3.webp`"
            alt=""
            class="article-image"
          />

          <div class="paragraph-steps">
            <h4>
              {{ $t('graphicsSettings') }}
            </h4>
            <p class="paragraph-text">
              {{ $t('functionsAvailableFromGraphicsSettings') }}
            </p>
            <div class="step-block">
              <h5>
                {{ $t('basicSettings') }}
              </h5>
              <p class="step-element">
                {{ $t('defaultScreen') }}
              </p>
              <p class="step-element">
                {{ $t('quatitySettings') }}
              </p>
            </div>
            <div class="step-block">
              <h5>
                {{ $t('advancedSettings') }}
              </h5>
              <p class="step-element">
                {{ $t('smoothingWillMakeTheEdges') }}
              </p>
              <p class="step-element">
                {{ $t('adjustPostProcessingSettings') }}
              </p>
            </div>
          </div>
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-4.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-4.webp`"
            alt=""
            class="article-image"
          />
          <div class="paragraph-steps">
            <h4>
              {{ $t('lightningSettings') }}
            </h4>
            <p class="paragraph-steps-text">
              {{ $t('lightingSettings') }}
            </p>
            <div class="step-block">
              <h5>
                {{ $t('generalSettingsThree') }}
              </h5>
              <p class="step-element">
                {{ $t('selectEitherDayNight') }}
              </p>
              <p class="step-element">
                {{ $t('diffusedLightIntensity') }}
              </p>
              <p class="step-element">
                {{ $t('diffusedLightTemperature') }}
              </p>
              <p class="step-element">
                {{ $t('ambientLight') }}
              </p>
            </div>
            <div class="step-block">
              <h5>
                {{ $t('panoramicViewOutside') }}
              </h5>
              <p class="step-element">
                {{ $t('windowViewCustomise') }}
              </p>
              <p class="step-element">
                {{ $t('panoramaLightIntensity') }}
              </p>
              <p class="step-element">
                {{ $t('rotationAnglePanoramicView') }}
              </p>
            </div>
            <div class="step-block">
              <h5>
                {{ $t('sunlight') }}
              </h5>
              <p class="step-element">
                {{ $t('sunlightIntensity') }}
              </p>
              <p class="step-element">
                {{ $t('sunlightTemperature') }}
              </p>
              <p class="step-element">
                {{ $t('solarAngle') }}
              </p>
              <p class="step-element">
                {{ $t('fourSolarAltitude') }}
              </p>
            </div>
          </div>
          <div v-if="locale === 'ru'" class="image-carousel">
            <ImagesCustomSlider
              :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/interior-design-5-1.webp`,
                `${staticUrl}/images/interior-design-5-2.webp`,
              ]"
            />
          </div>
          <div v-else class="image-carousel">
            <ImagesCustomSlider
              :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/interior-design-en-5-1.webp`,
                `${staticUrl}/images/interior-design-en-5-2.webp`,
              ]"
            />
          </div>
          <div class="paragraph-steps">
            <h4>
              {{ $t('postProcessingSet') }}
            </h4>
            <p class="paragraph-steps-text">
              {{ $t('PostProcessingSettingsDesc') }}
            </p>
          </div>
          <img
            v-if="locale === 'ru'"
            :src="`${staticUrl}/images/interior-design-6.webp`"
            alt=""
            class="article-image"
          />
          <img
            v-else
            :src="`${staticUrl}/images/interior-design-en-6.webp`"
            alt=""
            class="article-image"
          />
          <div class="mb-5 mt-5">
            <h3 id="helpControl">
              {{ $t('helpControl') }}
            </h3>
            <p class="sub-paragraph-text">
              {{ $t('configureTheControl') }}
            </p>
          </div>
          <div v-if="locale === 'ru'" class="image-carousel">
            <ImagesCustomSlider
              :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/interior-design-7-1.webp`,
                `${staticUrl}/images/interior-design-7-2.webp`,
                `${staticUrl}/images/interior-design-7-3.webp`,
              ]"
            />
          </div>
          <div v-else class="image-carousel">
            <ImagesCustomSlider
              :height="null"
              width="100%"
              :images="[
                `${staticUrl}/images/interior-design-en-7-1.webp`,
                `${staticUrl}/images/interior-design-en-7-2.webp`,
                `${staticUrl}/images/interior-design-en-7-3.webp`,
              ]"
            />
          </div>
        </div>
        <div ref="notes" class="mb-10">
          <h3 id="notes" ref="notes">
            {{ $t('notes') }}
          </h3>
          <p>
            {{ $t('textBoxAppear') }}
          </p>
        </div>
        <img
          v-if="locale === 'ru'"
          :src="`${staticUrl}/images/interior-design-8.webp`"
          alt=""
          class="article-image"
        />
        <img
          v-else
          :src="`${staticUrl}/images/interior-design-en-8.webp`"
          alt=""
          class="article-image"
        />
        <div ref="roulette">
          <h3 id="roulette" ref="roulette" class="mt-5">
            {{ $t('roulette') }}
          </h3>
          <p>
            {{ $t('rouletteDesc') }}
          </p>
        </div>
        <div v-if="locale === 'ru'" class="image-carousel">
          <ImagesCustomSlider
            :height="null"
            width="100%"
            :images="[
              `${staticUrl}/images/interior-design-29-1.webp`,
              `${staticUrl}/images/interior-design-29-2.webp`,
              `${staticUrl}/images/interior-design-29-3.webp`,
            ]"
          />
        </div>
        <div v-else class="image-carousel">
          <ImagesCustomSlider
            :height="null"
            width="100%"
            :images="[
              `${staticUrl}/images/interior-design-en-29-1.webp`,
              `${staticUrl}/images/interior-design-en-29-2.webp`,
              `${staticUrl}/images/interior-design-en-29-3.webp`,
            ]"
          />
        </div>
        <div
          id="lock-unlock"
          ref="lock-unlock"
          class="sub-paragraph-block"
        >
          <h3 id="movingObjectsThroughWalls">
            {{ $t('movingObjectsThroughWalls') }}
          </h3>
          <p class="paragraph-text">
            {{ $t('movingObjectsThroughWallsInstructions') }}
          </p>
        </div>
        <div class="i-block">
          <div class="i-block-info">
            <div class="i-block-info-icon">
              <div class="info-icon-background">
                <div class="info-icon-text">
                  {{ $t('i') }}
                </div>
              </div>
            </div>
            <div class="i-block-info-text">
              {{ $t('modelPressB') }}
            </div>
          </div>
        </div>
        <img
          v-if="locale === 'ru'"
          :src="`${staticUrl}/images/interior-design-8-1.webp`"
          alt=""
          class="article-image"
        />
        <img
          v-else
          :src="`${staticUrl}/images/interior-design-en-8-1.webp`"
          alt=""
          class="article-image"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useI18n} from 'vue-i18n';

const {t, locale} = useI18n();
const runtimeConfig = useRuntimeConfig();
const staticUrl = runtimeConfig.public.vueAppStaticUrl;
</script>

<style scoped lang="scss">
@import 'css/help-center/help-center-general-ctyle';
</style>
